// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2d57x","colMaxWidth":"Table_colMaxWidth__2SC2q"};